import { createSlice } from '@reduxjs/toolkit';
import api from 'src/api/index';
import i18n from 'src/i18n';
import { showErrorToast } from './toast';

const initialState = {
	list: [],
	lastFetchTime: null // Время последней загрузки тегов
};

const tagsSlice = createSlice({
	name: 'tags',
	initialState,
	reducers: {
		setTagsList: (state, action) => {
			state.list = action.payload;
			state.lastFetchTime = Date.now();
		},
		addTagsItem: (state, action) => {
			state.list.push(action.payload);
		},
		removeTagsItem: (state, action) => {
			state.list = state.list.filter((item) => action.payload !== item.id);
		},
	}
});

export const { setTagsList, addTagsItem, removeTagsItem } = tagsSlice.actions;

export const fetchTagsList = (force = false) => async (dispatch, getState) => {
	const state = getState();
	const { lastFetchTime, list } = state.tags;
	
	// Проверяем нужно ли обновлять (если прошло меньше 30 минут и есть данные)
	const CACHE_DURATION = 30 * 60 * 1000; // 30 минут
	const isCacheValid = lastFetchTime && (Date.now() - lastFetchTime < CACHE_DURATION) && list.length > 0;
	
	if (!force && isCacheValid) {
		console.log('📋 Теги загружены из кеша');
		return;
	}

	try {
		console.log('📋 Загружаем теги с сервера...');
		const res = await api.tagsList();
		dispatch(setTagsList(res.list));

	} catch (error) {
		console.error('❌ Ошибка загрузки тегов:', error);
		// Если пользователь не авторизован - это нормально, просто оставляем пустой список
		dispatch(setTagsList([]));
	}
};

export const createTag = (tag) => async (dispatch) => {

	try {

		const res = await api.createTag(tag);

		if (res) {

			dispatch(addTagsItem(tag));

		} else {

			throw Error();

		}

	} catch (error) {

		dispatch(showErrorToast({
			description: i18n.t('toasts.failedCreateTag'),
		}));

		throw error;
		
	}

};

export const getTagItem = (id) => (dispatch, getState) => {
	
	const state = getState();
	const findItem = state.tags.list.find(item => item.id === id);
	
	return findItem;
	
};

export default tagsSlice.reducer;